/**
 * SEO 配置 - chat (Deutsch)
 */

export default {
    chat: {
        title: 'KI-Chat - Multi-Modell-Assistent | WeryAI',
        description:
            'Chatten Sie mit Top-KI-Modellen auf WeryAI. Vergleichen Sie Antworten nebeneinander in mehreren Fenstern. Erstellen Sie Bilder, Videos und Musik in einem Arbeitsbereich.',
        keywords:
            'KI-Chat, KI-Assistent, Multi-Modell-Chat, KI-Chatbot, KI-Modelle vergleichen, nebeneinander KI-Chat, GPT-Alternative, KI-Arbeitsbereich, WeryAI',
        og_title: 'KI-Chat - Multi-Modell-Assistent | WeryAI',
        og_description:
            'Chatten Sie mit Top-KI-Modellen und vergleichen Sie Antworten nebeneinander. Erstellen Sie Bilder, Videos und mehr. Kostenlos auf WeryAI testen.',
        twitter_title: 'KI-Chat - Multi-Modell-Assistent | WeryAI',
        twitter_description:
            'Chatten Sie mit Top-KI-Modellen und vergleichen Sie Antworten nebeneinander. Erstellen Sie Bilder, Videos und mehr. Kostenlos auf WeryAI testen.',
    },
}
